export const CATEGORY_LEGEND = {
  OOO: {
    name: "Out of Office",
    definition: "Provider is temporarily unavailable (vacation, leave, illness).",
  },
  CLINIC_CLOSED: {
    name: "Clinic Closed",
    definition: "Clinic or office is closed temporarily or permanently, and appointments cannot be scheduled during that time.",
  },
  PROVIDER_START_END: {
    name: "Provider Start/End",
    definition: "Provider start or end date at a practice, including onboarding, departure, or corrections to termination messages. May include specific dates. Provider has permanently left the practice.",
  },
  NOT_ON_PAC_SPECIALTY_SERVICE: {
    name: "Specialty Not on PAC",
    definition: "A certain specialty or service is not on PAC.",
  },
  NOT_ON_PAC_PRACTICE: {
    name: "Practice Not on PAC",
    definition: "Clinic is not on pac.",
  },
  NOT_ON_PAC_PROVIDER: {
    name: "Provider Not on PAC",
    definition: "Specific provider is not on PAC and must be transferred to another number or specialty line.",
  },
  PROVIDER_LOCATION_CHANGE: {
    name: "Provider Moved",
    definition: "Provider has moved to a new physical location or started seeing patients at a new site.",
  },
  PRACTICE_LOCATION_CHANGE: {
    name: "Practice Moved",
    definition: "Practice has moved to a new physical location.",
  },
  UTILITY_ISSUES: {
    name: "Utility Outage",
    definition: "Operational disruptions such as power, phone, or internet outages that temporarily affect scheduling or communication.",
  },
  SCHEDULING_RULE: {
    name: "Scheduling Rules",
    definition: "Defines specific scheduling rules or preferences for visit types, durations, or modalities (e.g., telehealth times, visit length, new patient slots).",
  },
  ADMIN_INFO: {
    name: "Other Guidance",
    definition: "Administrative or operational guidance about scheduling order, MAWV nurse visits, record handling, or walk-in procedures.",
  },
  SERVICE_SCOPE: {
    name: "Service Change",
    definition: "Provider or practice has changed the scope of services, limiting or stopping certain treatments, age groups, or locations for specific services.",
  },
  INSURANCE_NOTICE: {
    name: "Insurance Notice",
    definition: "Information about insurance credentialing, plan acceptance, or corrections to payer communications. May instruct to verify coverage before scheduling.",
  },
  LIMITED_AVAILABILITY: {
    name: "Limited Availability",
    definition: "Provider is practicing with limited availability (PRN, part-time, procedural-only, or telehealth-only). Reduced access but still active.",
  },
  COVID_POLICY: {
    name: "COVID Policy",
    definition: "COVID-related restrictions or screening requirements affecting in-person scheduling or patient access.",
  },
  INMATE_TRANSFER: {
    name: "Inmate Transfer",
    definition: "Notes referencing inmate or correctional facility patient scheduling and transfer handling.",
  },
  VIRTUAL_WAITING_ROOM: {
    name: "Virtual Waiting Room",
    definition: "Instructions related to the Virtual Waiting Room (VWR) workflow for scheduling sooner or follow-up appointments.",
  },
} as const;

export type CategoryKey = keyof typeof CATEGORY_LEGEND;
